import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { NotificationsState } from '@portals/store';
import { BaseComponent } from '@portals/core';
import { Notification, NotificationRecents } from '@portals/api';
import { NotificationStateEnum } from '@portals/api';
import { NotificationPreviewComponent } from '../../notification-preview';
import { DialogPosition, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize, tap } from 'rxjs';

@Component({
	selector: 'portals-dashboard-posts',
	templateUrl: './posts.component.html',
	styleUrls: ['./posts.component.scss'],
})
export class PostsComponent extends BaseComponent implements OnInit {
	@ViewChild('notifyIcon', { static: true }) notifyIconRef!: ElementRef;
	posts: Notification[] = [];
	data: NotificationRecents[] = [];
	previewDialog!: MatDialogRef<NotificationPreviewComponent>;
	mousePosition = 0;
	mouseInbound!: boolean;
	state = NotificationStateEnum;
	formLoading = false;
	images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
	constructor(public notifications: NotificationsState, private dialog: MatDialog) {
		super();
	}

	ngOnInit(): void {
		this.formLoading = true;
		this.subscribe(
			this.notifications.getTopMostRecentFeeds().pipe(
				tap((data) => {
					this.data = data;
				}),
				finalize(() => {
					this.formLoading = false;
				})
			)
		);
	}
	openDialog(event: any, post: Notification): void {
		this.mouseInbound = true;
		const dialogWidth = 'auto'; // Set the width of the dialog content
		const dialogHeight = 'auto'; // Set the height of the dialog content
		const viewportWidth = window.innerWidth;
		const viewportHeight = window.innerHeight;
		const dialogPosition: DialogPosition = {
			right: '45px',
		};

		if (event.x + parseInt(dialogWidth) > viewportWidth) {
			dialogPosition.left = viewportWidth - parseInt(dialogWidth) + 'px';
		}

		if (event.y + parseInt(dialogHeight) > viewportHeight) {
			dialogPosition.top = viewportHeight - parseInt(dialogHeight) + 'px';
		}
		// console.log(post);
		this.subscribe(
			this.notifications.loadItem(<number>post.id).pipe(
				tap((data) => {
					post
						? (this.previewDialog = this.dialog.open(NotificationPreviewComponent, {
								data: {
									notification: data,
								},
								width: 'auto',
								panelClass: 'intake-notification-dialog',
								position: dialogPosition,
						  }))
						: null;
				})
			)
		);

		this.previewDialog.afterOpened().subscribe(() => {
			this.previewDialog.componentInstance.mouseWatch.emit(true);
		});

		this.previewDialog.componentInstance.mouseWatch.subscribe((result) => {
			this.mouseInbound = result;
			const notifyIcon = this.notifyIconRef.nativeElement;

			document.addEventListener('mousemove', (event) => {
				const mouseX = event.clientX;
				const mouseY = event.clientY;
				const divRect = notifyIcon.getBoundingClientRect();
				const divX = divRect.left;
				const divY = divRect.top;
				this.mousePosition = Math.sqrt((mouseX - divX) ** 2 + (mouseY - divY) ** 2);
				if (!this.mouseInbound) {
					this.previewDialog.close();
				}
			});
		});
	}
}
